import { Checkbox, Text, Box } from "@radix-ui/themes";
import { Control, Controller, FieldErrors } from "react-hook-form";
import styles from './CheckboxComponent.module.scss';

interface CheckboxProps {
  name: string;
  label: string;
  control: Control<any>;
  errors: FieldErrors<any>;
  style?: React.CSSProperties;
  defaultChecked?: boolean;
  disabled?: boolean;
  required?: boolean;
  onChange?: (checked: boolean) => void;
}

const CheckboxComponent = ({
  name,
  label,
  control,
  errors,
  style,
  defaultChecked = false,
  disabled = false,
  required = false,
  onChange,
}: CheckboxProps) => {
  return (
    <Box style={style}>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultChecked}
        render={({ field }) => (
          <Box style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Checkbox
              size="1"
              defaultChecked={defaultChecked}
              checked={field.value}
              disabled={disabled}
              onCheckedChange={(checked) => {
                field.onChange(checked);
                onChange?.(checked as boolean);
              }}
              id={name}
            />
            <Text as="label" size="2" htmlFor={name} className={styles.label}>
              {label} {required && <span style={{ color: 'red' }}>*</span>}
            </Text>
          </Box>
        )}
      />
      {errors?.[name] && (
        <Text color="red" size="1">
          {errors?.[name]?.message?.toString()}
        </Text>
      )}
    </Box>
  );
};

export default CheckboxComponent;